export type TFormTemplateCounts = {
  total: number;
  draft: number;
  published: number;
  archived: number;
};

export const FORM_TEMPLATE_STATUS = {
  Draft: "Draft",
  Archived: "Archived",
  Published: "Published",
  Unknown: "Unknown",
} as const;
